import axios from 'axios';

const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    // When visiting on the admin subdomain in production
    if (host === 'admin.fajtech.ca' || host.startsWith('admin.')) {
      return process.env.REACT_APP_API_URL || 'https://fajtech.ca/api';
    }
    // When on the main domain
    if (host === 'fajtech.ca' || host.endsWith('fajtech.ca')) {
      return '/api';
    }
    // Local development
    if (host === 'localhost' || host === '127.0.0.1') {
      return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    }
  }
  return process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'production' ? 'https://fajtech.ca/api' : 'http://localhost:5000/api'
  );
};

const API_BASE_URL = getBaseUrl();

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('fajtech_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('fajtech_refresh_token');
        if (refreshToken) {
          const res = await axios.post(`${API_BASE_URL}/auth/refresh`, { refreshToken }, { withCredentials: true });
          const newAccessToken = res.data.accessToken;
          localStorage.setItem('fajtech_access_token', newAccessToken);
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosClient(originalRequest);
        }
      } catch (refreshErr) {
        localStorage.removeItem('fajtech_access_token');
        localStorage.removeItem('fajtech_refresh_token');
        localStorage.removeItem('fajtech_user');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
